export default __webpack_public_path__ + "static/media/NDME0696.604d186a.jpeg";